<div class="quiz-toggle__container rounded-4">
  <div class="quiz-toggle__item qti--left rounded-4"
       [ngClass]="{'active-item': isLeftActive}"
       (click)="selectItem(1)">
    <span class="fs-5">{{ leftLabel }}</span>
  </div>
  <div class="quiz-toggle__item qti--right rounded-4"
       [ngClass]="{'active-item': !isLeftActive}"
       (click)="selectItem(2)">
    <span class="fs-5">{{ rightLabel }}</span>
  </div>
</div>
